import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closePopup } from '../action';
import './style.scss';


const ErrorModalEcart = (props) => {

    const { closePopup, okAction, message } = props;

    const onOkClick = () =>{
        okAction();
        closePopup();
    }

    return (
        <div>
            <div className='popupOuter'>
                <div className='popupSec' style={{textAlign: 'center'}}>
                    <div>
                        <h4 className='message' dangerouslySetInnerHTML={{__html: message}} />
                    </div> 
                    <button className='ok-button' onClick={onOkClick}>OK</button>
                </div>
            </div>
            <div className='popup_overlay black_overlay' />
        </div>
    );

}

const mapDispatchToProps = (dispatch) => ({
    closePopup: bindActionCreators(closePopup, dispatch),
});

export default connect('',mapDispatchToProps)(ErrorModalEcart);
